import React, { useState } from "react";
import { Table1 } from "../../../../Administration/Table1/Table1";
import { TransactionsTablecoloumn, setTransactionsTableData } from "./Data";
import "./financialtab.css";
import { LoadPanel, Popup } from "devextreme-react";
import { useEffect } from "react";
import { handleGetLocal } from "../../../../../services/auth-service";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ApiError } from "../../../../Error/ApiError";
import { VoidWriteOffPopup } from "./VoidWriteOffPopup";
import { logOut } from "../../../../../components/Logout";

export const Transactions = ({ userinfo }) => {
  const [load, setLoad] = useState(false);
  const [transactionTableData, setTransactionTableData] = useState([]);
  const [transactionrowData, settransactionRowData] = useState({});
  const navigate = useNavigate();
  const [errorhandling, seterrorhandling] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const [voidPopup, setvoidPopup] = useState(false);

  const getTransactionList = async () => {
    setLoad(true);
    const pathname = handleGetLocal("pathURL");
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/Financial/getTransactions?gPersonId=${userinfo?.gPersonId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        }
      )
      .then((val) => {
        setLoad(false);
        if (val?.data?.isSuccess) {
          seterrorhandling(false);
          setTransactionTableData(setTransactionsTableData(val?.data?.data));
        } else {
          seterrorhandling(true);
        }
      })
      .catch((val) => {
        setLoad(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        } else {
          seterrorhandling(true);
        }
      });
  };

  useEffect(() => {
    getTransactionList();
  }, [userinfo?.gPersonId]);

  console.log('rowData',transactionrowData)
  return (
    <>
     <Popup
        visible={voidPopup}
        onHiding={() => {
          setvoidPopup(false);
        }}
        showTitle={false}
        width={800}
        height={450}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <VoidWriteOffPopup
          setvoidPopup={setvoidPopup}
          userinfo={userinfo}
          obligationId={transactionrowData?.val?.gObligationId}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          gWriteOffID={transactionrowData?.val?.gRecordId}
        />
      </Popup>
      <LoadPanel shadingColor="true" visible={load} delay={10} />
      {errorhandling ? (
        <ApiError />
      ) : (
        <div className="payment_plan_tab">
          <div className="obligation_tab_table">
            <Table1
              editTable={false}
              height={"auto"}
              Tablecoloum={TransactionsTablecoloumn}
              tableRow={transactionTableData?.map((val, i) => {
                return { ...val, ID: i };
              })}
              load={load}
              coloumWidthText={"Transactions"}
              mandatoryColoum={"Docket"}
              TransactionsMenu={true}
              setvoidPopup={setvoidPopup}
              settransactionRowData={settransactionRowData}
            />
          </div>
        </div>
      )}
    </>
  );
};
